export default "__VITE_ASSET__BHBDtVwe__"